import { get } from 'lodash';

const styles = ({ color }) => ({
  copyUrl: {
    marginRight: 8,
    padding: 0,
    '& > span > p': {
      color: get(color, 'link'),
    },
  },
  paperClass: {
    height: 520,
    width: 600,
  },
});

export default styles;
